<!-- =========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div v-if="userData && userData._id" class="layout--full-page" ref="layout">
    <!-- gala templates -->
    <light-character-card
      v-if="userData.resumeTemplate === 'lightcharactercard'"
    />
    <dark-character-card
      v-else-if="userData.resumeTemplate === 'darkcharactercard'"
    />
    <grey-line
      v-else-if="userData.resumeTemplate === 'greyline'"
      class="resume-preview"
    />
    <prestige v-else class="resume-preview" />
  </div>
</template>

<script>
import organizationConfig from "@/assets/data/organization-config.js";
import GreyLine from "../components/editor/templates/GreyLine/GreyLine.vue";
import Prestige from "../components/editor/templates/Prestige/Prestige.vue";
import LightCharacterCard from "../components/editor/templates/Gala/LightCharacterCard.vue";
import DarkCharacterCard from "../components/editor/templates/Gala/DarkCharacterCard.vue";

export default {
  components: { GreyLine, Prestige, LightCharacterCard, DarkCharacterCard },
  data() {
    return {
      loggedInUserIsValid: false,
    };
  },
  computed: {
    userData() {
      return this.$store.state.users.data;
    },
    boardSlug() {
      return this.$route.params.boardSlug;
    },
    boardUserId() {
      return this.$route.params.boardUserId;
    },
    loggedInUser() {
      return this.$store.state.auth.user;
    },
    isUserLoggedIn() {
      return this.$store.state.auth.isUserLoggedIn;
    },
    userOrganizations() {
      return this.$store.state.users.userOrganizations;
    },
  },
  watch: {
    userData() {
      this.fetchUserOrganizations();
    }
  },
  mounted() {},
  methods: {
    // _goToDashboard() {
    //   window.location.href = '/user/dashboard';
    //   return;
    // },
    _goToLockedProfile() {
      // window.location.href = "/locked-profile";
      return;
    },
    async verifyBoardUser() {
      try {
        // verify board user
        const boardSlug = this.$route.params.boardSlug;
        const boardUserId = this.$route.params.boardUserId;

        if (boardSlug && boardUserId && this.isUserLoggedIn) {
          const boardRes = await this.$store.dispatch(
            "boards/fetchBoardBySlug",
            boardSlug
          );
          //console.log('1');
          if (boardRes.total !== 1) {
            //console.log('2');
            this._goToLockedProfile();
          } else if (
            boardRes &&
            boardRes.data &&
            boardRes.data[0] &&
            boardRes.data[0].status !== "active"
          ) {
            //console.log('3');
            this._goToLockedProfile();
          } else {
            const boardUserRes = await this.$store.dispatch(
              "boards/fetchUniqueBoardUser",
              { boardId: boardRes.data[0]._id, boardUserId }
            );
            //console.log(boardUserRes, { boardId: boardRes.data[0]._id, boardUserId });
            //console.log('4');
            if (boardUserRes.total !== 1) {
              //console.log('5');
              this._goToLockedProfile();
            } else if (
              this.isUserLoggedIn &&
              this.userData &&
              boardUserRes.data[0].userId !== this.userData._id
            ) {
              // console.log("6", boardUserRes.data[0].userId, this.userData._id);
              this._goToLockedProfile();
            }
          }
        } else {
          this._goToLockedProfile();
        }
      } catch (err) {
        throw err;
      }
    },
    async fetchLoggedInUserOrganizations(email, userId, boardOrgId) {
      if (email && userId && boardOrgId) {
        let orgCount = 0;
        const org = await this.$store.dispatch(
          "organization/onlyFetchAllMyOrganizations",
          { email, userId }
        );
        if (org && (org.superOrgs.length || org.subOrgs.length)) {
          org.superOrgs.forEach((org) => {
            if (org._id === boardOrgId) {
              orgCount++;
            }
          });

          org.subOrgs.forEach((org) => {
            if (org.organizationId === boardOrgId) {
              orgCount++;
            }
          });

          if (orgCount === 0) {
            this._goToLockedProfile();
          }
        } else {
          return null;
        }
      } else {
        this._goToLockedProfile();
      }
    },
    async fetchBoardOrgId(boardSlug) {
      if (boardSlug) {
        const board = await this.$store.dispatch(
          "boards/fetchBoardBySlug",
          boardSlug
        );
        if (board.total === 1 && board.data[0].organizationId) {
          return board.data[0].organizationId;
        }
        return null;
      } else {
        this._goToLockedProfile();
      }
    },
    fetchUserOrganizations() {
      if (this.userData && this.userData._id) {
        this.$store.dispatch("users/fetchUserOrganizations", {
          userId: this.userData._id,
        });
      }
    },
  },
  async created() {
    // this.$vs.loading();

    // Logic for public view
    const organizationSlug = this.$route.params.organizationSlug;
    const userSlug = this.$route.params.userSlug;

    const userDataRes = await this.$store.dispatch(
      "users/fetchUserBySlug",
      userSlug
    );

    if (!userDataRes) {
      this._goToLockedProfile();
    }

    if (this.boardSlug && this.boardUserId) {
      await this.verifyBoardUser();

      const boardOrgId = await this.fetchBoardOrgId(this.boardSlug);
      if (boardOrgId) {
        await this.fetchLoggedInUserOrganizations(
          this.loggedInUser.email,
          this.loggedInUser._id,
          boardOrgId
        );
        // if you have reached here, loggedin user is valid
        this.loggedInUserIsValid = true;
      }
    }

    if (
      organizationSlug &&
      !Object.keys(organizationConfig).includes(organizationSlug)
    )
      window.location.href = "/error-404";

    if (!organizationSlug)
      this.$store.commit("organization/SET_ORGANIZATION_SLUG", "default");
    else
      this.$store.commit(
        "organization/SET_ORGANIZATION_SLUG",
        organizationSlug
      );

    // If user resume status is private
    if (
      userDataRes &&
      userDataRes.resumeStatus === "private" &&
      !this.loggedInUserIsValid
    ) {
      this._goToLockedProfile();
      return;
    }

    if (userDataRes && userDataRes.firstName)
      document.title = `${userDataRes.firstName} ${userDataRes.lastName} | Talent Card | GetBoarded`;

    this.$store.commit("users/SET_USER_DATA", userDataRes);

    this.$store.commit(
      "editor/SET_PERSONAL_EVALUATION",
      userDataRes.personalEvaluation[0]
    );

    this.$store.commit("editor/SET_CAREER_HISTORY", userDataRes.careerHistory);

    this.$store.commit(
      "editor/SET_EDUCATIONAL_QUALIFICATIONS",
      userDataRes.educationalQualifications[0]
    );

    this.$store.commit("editor/SET_PROJECTS", userDataRes.projects);

    this.$store.commit(
      "editor/SET_EXTRA_CURRICULAR",
      userDataRes.extraCurricular[0]
    );

    this.$store.commit("editor/SET_PERSONALITY", userDataRes.personality[0]);

    this.fetchUserOrganizations();

    // this.$vs.loading.close();
  },
};
</script>

<style scoped>
.layout--full-page {
  margin: 0 10rem 0 10rem;
}
@media only screen and (max-width: 1024px) {
  .layout--full-page {
    margin: 0 5rem 0 5rem;
  }
}

@media only screen and (max-width: 991px) {
  .layout--full-page {
    margin: 0;
  }
}
</style>